import styled from "styled-components";

export const Styles = styled.div<{ rowHeightQlEditor?: number }>`
  width: 100%;
  .ql-editor {
    height: ${(props) => props.rowHeightQlEditor}px;
  }
`;
